import React, { useState } from 'react';
import '../styles/StatusPage.css';

function StatusPage({ onBack }) {
  const [searchNumber, setSearchNumber] = useState('');
  const [demandData, setDemandData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchNumber.trim()) {
      setError('Veuillez entrer un numéro de demande');
      return;
    }

    setLoading(true);
    setError(null);
    setDemandData(null);
    setSearched(true);

    try {
      const response = await fetch(`https://admin.cgiibnn-esursi.cd/api/equivalences/?search=${searchNumber}`);
      
      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setDemandData(data[0]);
          console.log('Demande trouvée:', data[0]);
        } else {
          setError('Aucune demande trouvée pour ce numéro');
        }
      } else {
        setError('Erreur lors de la recherche. Veuillez vérifier le numéro de demande.');
      }
    } catch (err) {
      console.error('Erreur:', err);
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <header className="app-header">
        <img src="/app-logo.png" alt="app logo" className="app-logo-header" />
        <h1 className="header-title">État de votre demande</h1>
        <button className="btn-back-header" onClick={onBack}>
          <i className="bi bi-arrow-left"></i> Retour
        </button>
      </header>

      <div className="status-page-container">
        {!demandData ? (
          <div className="search-section">
            <div className="search-card">
              <div className="search-header">
                <h2>Consulter votre demande d'équivalence</h2>
                <p>Entrez votre numéro de demande pour voir l'état de votre dossier</p>
              </div>

              <form onSubmit={handleSearch} className="search-form">
                <div className="form-group">
                  <label htmlFor="searchNumber">Numéro de demande</label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="searchNumber"
                      value={searchNumber}
                      onChange={(e) => setSearchNumber(e.target.value.toUpperCase())}
                      placeholder="EQUIXXXXXX"
                      className="search-input"
                      disabled={loading}
                    />
                    <span className="input-hint">Format: EQUIXXXXXX</span>
                  </div>
                </div>

                {error && <div className="error-message">
                  <span className="error-icon"><i className="bi bi-x-circle-fill"></i></span>
                  {error}
                </div>}

                <button
                  type="submit"
                  className="search-button"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      Recherche en cours...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-search"></i> Rechercher
                    </>
                  )}
                </button>
              </form>

              {searched && !demandData && !loading && (
                <div className="empty-state">
                  <p>Aucune demande trouvée</p>
                  <button
                    type="button"
                    onClick={() => {
                      setSearchNumber('');
                      setError(null);
                      setSearched(false);
                    }}
                    className="retry-button"
                  >
                    Essayer un autre numéro
                  </button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="result-section">
            <button
              className="back-search-button"
              onClick={() => {
                setDemandData(null);
                setSearchNumber('');
                setError(null);
                setSearched(false);
              }}
            >
              <i className="bi bi-arrow-left"></i> Nouvelle recherche
            </button>

            <div className="demand-card">
              <div className="card-header">
                <div className="header-top">
                  <div>
                    <h2 className="demand-number">{demandData.numero_demande}</h2>
                    <p className="demand-person">
                      {demandData.nom} {demandData.postnom} {demandData.prenom}
                    </p>
                  </div>
                  <div className={`status-badge status-${demandData.statut}`}>
                    {demandData.statut_display}
                  </div>
                </div>
                <div className="header-meta">
                  <span className="meta-item">
                    <strong>Soumis le:</strong> {new Date(demandData.date_soumission).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </span>
                </div>
              </div>

              <div className="card-content">
                <div className="info-section">
                  <h3>Informations personnelles</h3>
                  <div className="info-grid">
                    <div className="info-item">
                      <span className="label">Nom</span>
                      <span className="value">{demandData.nom}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Post-nom</span>
                      <span className="value">{demandData.postnom}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Prénom</span>
                      <span className="value">{demandData.prenom}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Adresse</span>
                      <span className="value">{demandData.adresse}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Email</span>
                      <span className="value">{demandData.email}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Téléphone</span>
                      <span className="value">{demandData.telephone}</span>
                    </div>
                  </div>
                </div>

                <div className="info-section">
                  <h3>Établissement</h3>
                  <div className="info-grid">
                    <div className="info-item">
                      <span className="label">Nom de l'établissement</span>
                      <span className="value">{demandData.nom_etablissement || 'Non renseigné'}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Email</span>
                      <span className="value">{demandData.email_etablissement || 'Non renseigné'}</span>
                    </div>
                    <div className="info-item full-width">
                      <span className="label">Statut juridique</span>
                      <span className="value">{demandData.statut_juridique_display}</span>
                    </div>
                  </div>
                </div>

                <div className="info-section">
                  <h3>Documents téléchargés</h3>
                  <div className="documents-grid">
                    {demandData.lettre_demande && (
                      <a href={demandData.lettre_demande} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Lettre de demande</span>
                      </a>
                    )}
                    {demandData.copie_diplome && (
                      <a href={demandData.copie_diplome} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Copie du diplôme</span>
                      </a>
                    )}
                    {demandData.releves_cotes && (
                      <a href={demandData.releves_cotes} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Relevés de côtes</span>
                      </a>
                    )}
                    {demandData.titre_academique_rdc && (
                      <a href={demandData.titre_academique_rdc} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Titre académique RDC</span>
                      </a>
                    )}
                    {demandData.baccalaureat && (
                      <a href={demandData.baccalaureat} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Baccalauréat</span>
                      </a>
                    )}
                    {demandData.composition_jury && (
                      <a href={demandData.composition_jury} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Composition du jury</span>
                      </a>
                    )}
                    {demandData.pv_soutenance && (
                      <a href={demandData.pv_soutenance} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">PV de soutenance</span>
                      </a>
                    )}
                    {demandData.titre_sejour && (
                      <a href={demandData.titre_sejour} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Titre de séjour</span>
                      </a>
                    )}
                    {demandData.documents_version_francaise && (
                      <a href={demandData.documents_version_francaise} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Documents en français</span>
                      </a>
                    )}
                    {/* PREUVE DE PAIEMENT - COMMENTÉE */}
                    {/* {demandData.preuve_paiement && (
                      <a href={demandData.preuve_paiement} target="_blank" rel="noopener noreferrer" className="document-item">
                        <span className="doc-icon">📄</span>
                        <span className="doc-name">Preuve de paiement</span>
                      </a>
                    )} */}
                  </div>
                </div>

                {demandData.commentaires && (
                  <div className="info-section">
                    <h3>Commentaires</h3>
                    <p className="comment-text">{demandData.commentaires}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default StatusPage;
